import { Box, styled } from '@mui/material';

const HolographicBackground = styled(Box)(({ theme }) => ({
  position: 'relative',
  minHeight: '100vh',
  padding: theme.spacing(4),
  background: 'rgba(26, 26, 46, 0.95)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(45deg, rgba(0, 51, 102, 0.1), rgba(0, 204, 153, 0.1), rgba(138, 43, 226, 0.1))',
    animation: 'gradient 15s ease infinite',
    zIndex: 0,
  },
  '& > *': {
    position: 'relative',
    zIndex: 1,
  },
}));

export default HolographicBackground; 